import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '@containers/ProductDetailContainer/messages';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import { PD_NUTRITION_TABLE_ID } from '../AboutProduct/constants';
import { NutritionTable } from '../AboutProduct/styled';

import { Text, Wrapper, SectionTitle } from './styled';

interface CompositionProps {
  html: string;
  nutritionValues?: string;
}

export const Composition = ({ html, nutritionValues }: CompositionProps) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <Wrapper id={'pd-composition-wrapper'}>
      <SectionTitle newDesign={newDesign}>
        <FormattedMessage {...messages.fullComposition} />
      </SectionTitle>

      <Text
        newDesign={newDesign}
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />

      {nutritionValues ? (
        <NutritionTable
          data-testid={'nutrition-table'}
          id={PD_NUTRITION_TABLE_ID}
          dangerouslySetInnerHTML={{
            __html: nutritionValues,
          }}
        />
      ) : null}
    </Wrapper>
  );
};
